"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataAdapterCachePrefix = void 0;
exports.DataAdapterCachePrefix = 'statsig.cached';
